import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DataTable from "components/DataTable";
import Modal from "components/Modal";
import CompleteDemo from "pages/dashboard/completeDemo/CompleteDemo";
import React, { useState } from "react";

interface TaskDetails {
  employeeTask: any;
  isFiltered?: string; // Prop to indicate if data is filtered
  isSearchAccepting?: boolean
}

interface EmployeeTaskProps {
  employeeId: string;
  firstName: string;
  city: string;
  completedDemo: number;
  pending: number;
  managerName?: string
  managerCode?: string
  employeeCode?: string
}

interface ActionCellProps {
  row: object;
  onView: (row: any) => void;
}

const ActionCell: React.FC<ActionCellProps> = ({ row, onView }) => (
  <div className="flex space-x-2">
    <button
      onClick={() => onView(row)}
      className="p-2 
bg-blue-50 dark:bg-blue-900/40 
text-blue-600 dark:text-blue-300 
hover:bg-blue-100 dark:hover:bg-blue-900/60 
rounded-lg transition-colors"
      title="View Details"
    >
      <FontAwesomeIcon icon={faEye} />
    </button>
  </div>
);

const EmployeeTask = ({ employeeTask, isFiltered, isSearchAccepting = true }: TaskDetails) => {
  const [isOpenView, setIsOpenView] = useState(false);
  const [viewData, setViewData] = useState<EmployeeTaskProps | null>(null);

  console.log("EmployeeTask - isFiltered:", isFiltered);

  const handleView = (row: any) => {
    setIsOpenView(true);
    setViewData(row);
  };

  const column = [
    {
      key: "managerName",
      label: "Manager Name",
      headerClassName: "text-gray-800 dark:text-white",
      render: (_: any, row: any) => (
        <div className="flex flex-row item-center">
          <div>
            <div className="font-medium text-sm text-gray-800 dark:text-gray-200">{row.managerName || 'Direct'}</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              {(row.managerCode !== "N/A") && row.managerCode}
            </div>
          </div>
        </div>
        // <span>{row.managerCode ? `${row.managerCode}/${row.managerName}` : (row.managerName ?? "Direct")}</span>
      ),

    },

    {
      key: "Employee",
      label: "Employee Name",
      headerClassName: "text-gray-800 dark:text-white",
      render: (_: any, row: any) => (
        <div className="flex flex-row item-center">
          <div>
            <div className="font-medium text-gray-800 dark:text-gray-200">{row.firstName || 'Direct'}</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              {row.employeeCode && row.employeeCode}
            </div>
          </div>
        </div>
        // <span>{row.employeeCode ? `${row.employeeCode}/${row.firstName}` : (row.firstName ?? "—")}</span>
      ),

    },
    {
      key: "city",
      label: "Location",
      headerClassName: "text-gray-800 dark:text-white",
    },
    {
      key: "completedDemo",
      label: "Completed",
      headerClassName: "text-gray-800 dark:text-white",

    },
    {
      key: "pending",
      label: "Follow Up",
      headerClassName: "text-gray-800 dark:text-white"

    },
    {
      key: "actions",
      label: "Actions",
      headerClassName: "text-gray-800 dark:text-white",
      excludeExport: true,
      actions: (row: object) => <ActionCell row={row} onView={handleView} />,
    },
  ];

  return (
    <div className="w-full">
      <DataTable
        data={employeeTask}
        columns={column}
        isAddBtnTrue={false}
        isExport={false}
        isSearchBtn={isSearchAccepting}
      // className="rounded-lg overflow-hidden"
      />

      {isOpenView && (
        <Modal
          isOpen={isOpenView}
          onClose={() => setIsOpenView(false)}
          header="Demo Details"
          size="full"
          customHeight="90vh"
        >
          <CompleteDemo viewData={viewData} isFiltered={isFiltered} />
        </Modal>
      )}
    </div>
  );
};

export default EmployeeTask;
